<template>
  <a href="https://www.instagram.com/covid19visualproject/" target="_blank">
    <InstagramIcon class="icon" />
    <span>contact us</span>
  </a>
</template>

<script>
import InstagramIcon from '@/assets/svg/instagram.svg'

export default {
  name: 'ContactUsIcon',

  components: {
    InstagramIcon
  }
}
</script>

<style scoped lang="scss">

a {
  pointer-events: all;
  cursor: pointer;

  &:hover {
    span {
      color: $c-white;
    }

    .icon path {
      fill: $c-white;
    }
  }
}

.icon {
  width: 16px;
  height: 16px;
  vertical-align: top;
  display: inline-block;
}

span {
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;

  text-decoration: underline;

  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 12px;
  letter-spacing: normal;
  text-align: left;
  color: $c-text-grey;

  @include breakpoint('md-and-up') {
    font-size: 16px;
  }
}
</style>
